import { render } from "./InitialGame.vue?vue&type=template&id=122a764c&scoped=true"
import script from "./InitialGame.vue?vue&type=script&lang=js"
export * from "./InitialGame.vue?vue&type=script&lang=js"

import "./InitialGame.vue?vue&type=style&index=0&id=122a764c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-122a764c"

export default script